export default __webpack_public_path__ + "static/media/indicinaLogo.561b9c23.svg";